import { Row, RowCenter } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"


import {ReactComponent as SwapSvg } from 'assets/svgs/icn_swap.svg'
import {ReactComponent as MinimumSvg } from 'assets/svgs/icn_minimum.svg'
import {ReactComponent as GasSvg } from 'assets/svgs/icn_gas.svg'
import {ReactComponent as SlippageSvg } from 'assets/svgs/icn_slippage.svg'
import SlippageWarnCom from "./SlippageWarnCom"
import { useAppSelector } from "hooks/redux/hooks"
import useSwapRate from "hooks/useSwapRate"
import useIsCrossChain from "hooks/useIsCrossChain"
import { Tooltip } from "react-tooltip"

import { ReactComponent as WarnSvg } from 'assets/svgs/warn_icon.svg'
import { ReactNode } from "react"

const TransferInfoCom = () => {
    const { toToken, gas, slippage, miniToAmount} = useAppSelector((state) => state.coreInfo)
    const { swapRate, chaingeDirection } = useSwapRate()
    const { isCrossChain } = useIsCrossChain()

    return <TransferInfoWrap>
        <InfoWrap>
            <InfoLeftWrap>
                <SwapSvgWrap></SwapSvgWrap>
                <InfoLabelWrap $textDecoration="none !important" $color="#767A7F !important">Swap rate</InfoLabelWrap>
            </InfoLeftWrap>
            <InfoRightWrap $pointer onClick={chaingeDirection}>{swapRate}</InfoRightWrap>
        </InfoWrap>
        {
            !isCrossChain && <>
                <InfoWrap>
                    <InfoLeftWrap data-tooltip-id="tootltip_minimum">
                        <MinimumSvgWrap></MinimumSvgWrap>
                        <InfoLabelWrap>Minimum received</InfoLabelWrap>
                    </InfoLeftWrap>
                    <InfoRightWrap>{miniToAmount} {toToken?.symbol}</InfoRightWrap>
                </InfoWrap>
                <Tooltip id="tootltip_minimum" place="right" style={{ backgroundColor:  'transparent', width: '258px', padding: '0'}}>
                    <ToolTipCom>
                        You will get at least this amount, or the transaction will revert.
                    </ToolTipCom>
                </Tooltip>
            </>
        }
        <>
            <InfoWrap>
                <InfoLeftWrap data-tooltip-id="tootltip_estimated_fee">
                    <GasSvgWrap></GasSvgWrap>
                    <InfoLabelWrap>Estimated fee</InfoLabelWrap>
                </InfoLeftWrap>
                <InfoRightWrap>{gas} {toToken?.symbol}</InfoRightWrap>
            </InfoWrap>
            <Tooltip id="tootltip_estimated_fee" place="right" style={{ backgroundColor:  'transparent', width: '258px', padding: '0'}}>
                <ToolTipCom>
                    Approximate network & service fee for your transaction.
                </ToolTipCom>
            </Tooltip>
        </>
        <InfoWrap>
            <>
                <InfoLeftWrap $isSlippage={slippage >= 20} data-tooltip-id="tootltip_estimated_slippage">
                    <SlippageSvgWrap></SlippageSvgWrap>
                    <InfoLabelWrap>Estimated slippage</InfoLabelWrap>
                </InfoLeftWrap>
                <Tooltip id="tootltip_estimated_slippage" place="right" style={{ backgroundColor:  'transparent', width: '258px', padding: '0'}}>
                    <ToolTipCom>
                        {`You agree to receiving up to ${slippage}% less than the estimated output.`}
                    </ToolTipCom>
                </Tooltip>
            </>
            <InfoRightWrap>
                <SlippageWarnCom></SlippageWarnCom>
            </InfoRightWrap>
        </InfoWrap>

        
    </TransferInfoWrap>
}

export const ToolTipCom = ({children}: {children: ReactNode}) => {
    return <TipWrap>
        <WarnSvgWrap></WarnSvgWrap>
        <StyledContainer $ml="12px" $fontSize="12px" $lineHeight="14px" $fontWeight5 $flex1="1">
            {children}
        </StyledContainer>
    </TipWrap>
}

const TransferInfoWrap = styled(StyledContainer)`
    
`

const InfoWrap = styled(Row)`
    justify-content: space-between;
    padding: 0px 10px 10px 20px;
    margin-bottom: 16px;

    border-bottom: 1px solid #F2F2F2;
`

const InfoLabelWrap = styled(StyledContainer)`
    font-family: RoobertRegular;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: ${({theme}) => theme.lightBlack};
    text-decoration: underline;
`

const InfoRightWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 500;
    line-height: 14px; 
`

const SvgStyle = () => {
    return css`
        width: 16px;
        height: 16px;
        margin-right: 8px;
    `
}

const SwapSvgWrap = styled(SwapSvg)`
    ${SvgStyle()}
`

const MinimumSvgWrap = styled(MinimumSvg)`
    ${SvgStyle()}
`

const GasSvgWrap = styled(GasSvg)`
    ${SvgStyle()}
`

const SlippageSvgWrap = styled(SlippageSvg)`
    ${SvgStyle()}
`

const InfoLeftWrap = styled(Row)<{$isSlippage: boolean}>`
    cursor: pointer;
    &:hover {
        ${InfoLabelWrap} {
            color: ${({theme}) => theme.basicBlack};
        }
        ${SlippageSvgWrap}, ${MinimumSvgWrap}, ${GasSvgWrap} {
            rect, path {
                fill: ${({theme}) => theme.basicBlack};
            }
        }
    }
    ${
       ({$isSlippage, theme}) => $isSlippage ? css`
            ${InfoLabelWrap} {
                color: #E000E0 !important;
            }
            ${SlippageSvgWrap} {
                rect, path {
                    fill: #E000E0 !important;
                }
            }
       ` : ''
    }
`

const TipWrap = styled(RowCenter)`
    padding: 10px 16px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
`

const WarnSvgWrap = styled(WarnSvg)`
    width: 16px;
    height: 16px;
`

export default TransferInfoCom